import { makeAutoObservable } from 'mobx';
import DefaultCover from '../assets/default_author.png';
import validateUrl from '../helpers/validate_url';
import { createMainAuthor, getMainAuthor, updateMainAuthor } from '../services/main_author';

class MainAuthorFormStore {
  books = [];
  formDataTemplate = {
    id: null,
    name: '',
    image: '',
    image_source: '',
    bio: '',
    bio_source: '',
    site: '',
    instagram: '',
    books: []
  };

  isNew = false;

  formData = { ...this.formDataTemplate };

  loadedImage = null;

  errors = {
    id: false,
    name: false,
    image: false,
    image_source: false,
    bio: false,
    bio_source: false,
    site: false,
    instagram: false,
  };

  validators = {
    id: () => this.setErrors({ ...this.errors, id: false }),
    name: () => this.setErrors({ ...this.errors, name: this.formData.name.length < 2 }),
    image: () => this.setErrors({ ...this.errors, image: this.formData.image?.length > 0 && !validateUrl(this.formData.image) }),
    image_source: () => {
      let isValid = true;

      if (this.formData.image?.length > 0) {
        if (this.formData.image_source === null) {
          isValid = false;
        }

        if (this.formData.image_source?.length <= 0) {
          isValid = false;
        }
      }

      this.setErrors({ ...this.errors, image_source: !isValid });
    },
    bio: () => this.setErrors({ ...this.errors, bio: false }),
    bio_source: () => {
      let isValid = true;

      if (this.formData.bio?.length > 0) {
        if (this.formData.bio_source === null) {
          isValid = false;
        }

        if (this.formData.bio_source?.length <= 0) {
          isValid = false;
        }
      }

      this.setErrors({ ...this.errors, bio_source: !isValid });
    },
    site: () => this.setErrors({ ...this.errors, site: false }),
    instagram: () => this.setErrors({ ...this.errors, instagram: false }),
  };

  activeTab = 0;

  tabsErrors = [true];

  loading = false;

  snackStore = null;

  userStore = null;

  navigate = null;

  constructor(userStore, snackStore, navigate, isNew) {
    makeAutoObservable(this);
    this.userStore = userStore;
    this.snackStore = snackStore;
    this.navigate = navigate;
    this.isNew = isNew;
  }

  setLoading(loading) {
    this.loading = loading;
  }

  setErrors(errors) {
    this.errors = errors;

    const tabsValidation = [];

    const tabsValidators = [['id', 'name', 'bio', 'bio_source', 'image', 'image_source', 'site', 'instagram']];

    for (let i = 0; i < tabsValidators.length; i++) {
      tabsValidation[i] = tabsValidators[i].map(field => this.errors[field]).reduce((acc, curr) => acc || curr, false);
    }

    this.setTabsErrors(tabsValidation);
  }

  setActiveTab(tab) {
    this.activeTab = tab;
  }

  setTabsErrors(errors) {
    this.tabsErrors = errors;
  }

  setFormData(field, value) {
    this.formData = {
      ...this.formData,
      [field]: value
    };
    this.validateFields();
  }

  setLoadedImage(loadedImage) {
    this.loadedImage = loadedImage ?? DefaultCover;
    this.formData = {
      ...this.formData,
      image: loadedImage,
      use_default_cover: loadedImage === null
    };
    this.validateFields();
  }

  validateFields = () => {
    for (const key in this.validators) {
      this.validators[key]();
    }
  };

  loadAuthor = async (id) => {
    this.setLoading(true);

    try {
      const {data: {data:author}} = await getMainAuthor(id, this.userStore.token);
      this.books = author.books;
      delete author.books;
      this.formData = {
        ...this.formDataTemplate,
        ...author
      };
      this.setLoadedImage(author.image);
      this.setLoading(false);
    } catch (e) {
      this.snackStore.showErrorSnack('Erro ao carregar Autor-pai');
      this.setLoading(false);
      this.navigate(`/app/main/authors`);
    }
  }

  saveMainAuthor = async () => {
    if (this.loading) {
      return;
    }

    this.setLoading(true);

    try {
      if (this.isNew) {
        await createMainAuthor(this.formData, this.userStore.token);
      } else {
        await updateMainAuthor(this.formData, this.userStore.token);
      }
      this.setLoading(false);
      this.snackStore.showSuccessSnack(`Autor-pai "${this.formData.name}" salvo com sucesso`);
      this.navigate(`/app/main/authors`);
    } catch (e) {
      this.snackStore.showErrorSnack(e.response?.data?.error?.message ?? 'Erro ao salvar Autor-pai');
      this.setLoading(false);
    }
  }

}

export default MainAuthorFormStore;
